import { call, put, take, takeEvery, takeLatest } from "redux-saga/effects";
import { ADD_PARTICULAR_OWNER, GET_PARTICULAR_OWNER, GET_TOP_SALES, GET_VIEW_COUNT_OWNER, LIKE_VIEW_OWNER, UPDATE_PARTICULAR_OWNER } from "./actionType";
import { addParticularOwnerFail, addParticularOwnerSuccess, getAllParticularOwnerFail, getAllParticularOwnerSuccess, getParticularOwnerFail, getParticularOwnerSuccess, getTopSalesFail, getTopSalesSuccess, getviewCountOwnerFail, getviewCountOwnerSuccess, likeViewOwnerFail, likeViewOwnerSuccess, updateParticularOwnerFail, updateParticularOwnerSuccess } from "./actions";
import { addOwnerApi, fetchOwnerApi, getAllOwnerApi, getTopSaleApi, getviewCountApi, likeViewApi, updateOwnerApi } from "helpers/backend_helper";
import { GET_ALL_OWNER } from "helpers/url_helper";
import moment from 'moment';
import { converCryptoToDollar } from "helpers/constants";
function* fetchOwner({ payload: { data, callback } }) {
  try {
    const response = yield call(fetchOwnerApi, data);

    if (response.status === "failure") {
      return yield put(getParticularOwnerFail(response.message));
    }
    response.data.map((tr) => {
      let localtime = moment.unix(tr.created_date).local()
      tr.created_date = localtime.format('YYYY-MM-DD HH:mm:ss');
      return tr;
    })


    callback && callback(response);
    yield put(getParticularOwnerSuccess(response.data));
  } catch (error) {
    console.log("error", error);
    yield put(getParticularOwnerFail(""));
  }
}
function* addOwner({ payload: { data, callback } }) {
  try {
    const response = yield call(addOwnerApi, data);
    callback && callback(response);
    if (response.status === "failure") {
      return yield put(addParticularOwnerFail(response.message));
    }
    return yield put(addParticularOwnerSuccess(response.data));

  } catch (error) {
    console.log("error", error);
    yield put(addParticularOwnerFail(""));
  }
}

function* updateOwner({ payload: { data, callback } }) {
  try {
    const response = yield call(updateOwnerApi, data);

    if (response.status === "failure") {
      return yield put(updateParticularOwnerFail(response.message));
    }

    callback && callback(response);
    yield put(updateParticularOwnerSuccess(response.data));
  } catch (error) {
    console.log("error", error);
    yield put(updateParticularOwnerFail(""));
  }
}


function* getAllOwner({ payload: { data, callback } }) {
  try {
    const response = yield call(getAllOwnerApi, data);
    if (response.status === "failure") {
      return yield put(getAllParticularOwnerFail(response.message));
    }

    callback && callback(response);
    yield put(getAllParticularOwnerSuccess(response.data));
  } catch (error) {
    console.log("error", error);
    yield put(getAllParticularOwnerFail(error));
  }
}


function* getviewCount({ payload: { id, callback } }) {
  try {
    const response = yield call(getviewCountApi, id);
    if (response.status === "failure") {
      return yield put(getviewCountOwnerFail(response.message));
    }

    callback && callback(response);
    yield put(getviewCountOwnerSuccess(response.data));
  } catch (error) {
    console.log("error", error);
    yield put(getviewCountOwnerFail(error));
  }
}


function* likeViewOwner({ payload: { data, callback } }) {
  try {
    const response = yield call(likeViewApi, data);
    if (response.status === "failure") {
      return yield put(likeViewOwnerFail(response.message));
    }

    callback && callback(response);
    yield put(likeViewOwnerSuccess(response.data));
  } catch (error) {
    console.log("error", error);
    yield put(likeViewOwnerFail(error));
  }
}

function* getTopSale({ payload: { data, callback } }) {
  try {
    const response = yield call(getTopSaleApi, data);
    if (response.status === "failure") {
      return yield put(getTopSalesFail(response.message));
    }
    response.data.map(async (item) => {
      const momentObject = moment.unix(Number(item?.created_date));
      item.created_date = momentObject.format('YYYY-MM-DD HH:mm:ss');
      let amount = item?.price;
      let symbol = "MATIC";
      let data = await converCryptoToDollar(amount, symbol);
      item.usdPrice = data
      return item
    })
    callback && callback(response);
    yield put(getTopSalesSuccess(response.data));
  } catch (error) {
    console.log("error", error);
    yield put(getTopSalesFail(error));
  }
}

function* OwnersSaga() {
  yield takeEvery(GET_PARTICULAR_OWNER, fetchOwner);
  yield takeEvery(ADD_PARTICULAR_OWNER, addOwner);
  yield takeLatest(UPDATE_PARTICULAR_OWNER, updateOwner);
  yield takeEvery(GET_ALL_OWNER, getAllOwner);
  yield takeEvery(GET_VIEW_COUNT_OWNER, getviewCount);
  yield takeEvery(LIKE_VIEW_OWNER, likeViewOwner);
  yield takeEvery(GET_TOP_SALES, getTopSale);
}

export default OwnersSaga;
